import { render, staticRenderFns } from "./KeywordsExamples.vue?vue&type=template&id=c992bdee&scoped=true&"
import script from "./KeywordsExamples.vue?vue&type=script&lang=js&"
export * from "./KeywordsExamples.vue?vue&type=script&lang=js&"
import style0 from "./KeywordsExamples.vue?vue&type=style&index=0&id=c992bdee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c992bdee",
  null
  
)

export default component.exports